import * as React from "react"
const SvgTools = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m17.85 20.807-4.425-4.425 2.1-2.1 4.425 4.425q.425.425.425 1.05t-.425 1.05a1.43 1.43 0 0 1-1.05.425q-.625 0-1.05-.425m-13.8 0a1.43 1.43 0 0 1-.425-1.05q0-.625.425-1.05l5.85-5.85-1.7-1.7a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-.575-.575v2.25q0 .35-.3.475t-.55-.125L2.65 10.457q-.25-.25-.125-.55t.475-.3h2.25l-.55-.55a.96.96 0 0 1-.3-.7q0-.4.3-.7l2.85-2.85a3.1 3.1 0 0 1 1.075-.725Q9.2 3.857 9.8 3.857q.5 0 .938.15t.862.45q.2.125.213.35a.5.5 0 0 1-.163.4l-1.9 1.9.55.55a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l1.7 1.7 2.25-2.25a4 4 0 0 1-.162-.575q-.063-.3-.063-.6 0-1.474 1.013-2.487t2.487-1.013q.2 0 .375.013t.35.062q.225.075.288.313a.4.4 0 0 1-.113.412L16.8 6.257a.48.48 0 0 0 0 .7l1.1 1.1a.48.48 0 0 0 .7 0l1.625-1.625a.43.43 0 0 1 .413-.125q.237.05.312.3.05.175.063.35.012.176.012.375 0 1.475-1.012 2.488c-1.012 1.013-1.505 1.012-2.488 1.012q-.3 0-.6-.05a2.3 2.3 0 0 1-.575-.175l-10.2 10.2a1.43 1.43 0 0 1-1.05.425q-.625 0-1.05-.425" />
  </svg>
)
export default SvgTools
